import { render, staticRenderFns } from "./SurveyCardLoader.vue?vue&type=template&id=d8853706&scoped=true"
import script from "./SurveyCardLoader.vue?vue&type=script&lang=js"
export * from "./SurveyCardLoader.vue?vue&type=script&lang=js"
import style0 from "./SurveyCardLoader.vue?vue&type=style&index=0&id=d8853706&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8853706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8853706')) {
      api.createRecord('d8853706', component.options)
    } else {
      api.reload('d8853706', component.options)
    }
    module.hot.accept("./SurveyCardLoader.vue?vue&type=template&id=d8853706&scoped=true", function () {
      api.rerender('d8853706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/List/Loader/SurveyCardLoader.vue"
export default component.exports